import { Client } from "./_clientService";

async function getChallenges(options: any) {
  try {
    let payload: any = {
      pageNo: options?.pageNo,
      limit: options?.pageSize,
      sortKey: "createdAt",
      sortDir: "DESC",
      search: options?.search,
      skipPagination: options?.skipPagination ?? false,
    };
    if (options?.type) payload.type = options.type;
    if (options?.tier) payload.tier = options.tier;
    if (options?.status !== undefined && options?.status !== "")
      payload.status = options.status;
    let path = "/challenges/list";
    const resp = await new Client({ path, payload }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function getChallengeInfo(challengeId: any) {
  try {
    const resp = await new Client({
      path: "/challenges/info",
      payload: { challengeId },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function createChallenge(challengeDetails: any) {
  try {
    const resp = await new Client({
      path: "/challenges/create",
      payload: challengeDetails,
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function updateChallenge(challengeDetails: any, challengeId: any) {
  try {
    const resp = await new Client({
      path: "/challenges/update",
      payload: { ...challengeDetails, _id: challengeId },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

export async function deleteChallenge(challengeId: any) {
  const resp = await new Client({
    path: "/challenges/delete",
    payload: { challengeId },
  }).post();
  return resp;
}

export async function updateChallengeStatus(challengeId: any) {
  const resp = await new Client({
    path: "/challenges/update/status",
    payload: { challengeId },
  }).post();
  return resp;
}

export { getChallenges, getChallengeInfo, createChallenge, updateChallenge };
